import { UsuarioList } from "../../../../../types/usuario/UsuarioList";

export interface CentroApoio {
  id?: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  categoria: string;
  formatoContato: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  anonimo?: boolean;
}
export const IScentroApoio: CentroApoio = {
  id: '',
  categoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  dataHoraCriacao: '',
  anonimo: false
};
export interface CentroApoioList {
  id: string;
  categoria: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  anonimo?: boolean;
  formatoContato: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  arquivado?: boolean;
  resposta?: string;
  usuarioResposta?: UsuarioList | null;
  dataHoraResposta?: Date | string;
}
export const IScentroApoioList: CentroApoioList = {
  id: '',
  categoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  anonimo: false,
  dataHoraCriacao: '',
  arquivado: false,
  resposta: '',
  usuarioResposta: null,
  dataHoraResposta: ''
};

export interface CentroApoioDTO {
  id: string;
  idCategoria: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  anonimo?: boolean;

  formatoContato: string;
  observacao: string;
}
export const IScentroApoioDTO: CentroApoioDTO = {
  id: '',
  idCategoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  anonimo: false
};

export interface CentroApoioRespostaDTO {
  id: string;
  resposta: string;
}
export const IScentroApoioRespostaDTO: CentroApoioRespostaDTO = {
  id: '',
  resposta: ''
};

export interface CentroApoioLoginResponse {
  id: string;
  login: string;
  senha: string;
}
export const IScentroApoioLoginResponse: CentroApoioLoginResponse = {
  id: '',
  login: '',
  senha: ''
};

export interface CentroApoioLogin {
  login: string;
  senha: string;
}
export const IScentroApoioLogin: CentroApoioLogin = {
  login: '',
  senha: ''
};

export interface CentroApoioListPublicResponse {
  results: CentroApoioList[];
  count: number;
  next: string | null;
  previous: string | null;
}
